import Vue from "vue"
import vueResource from "vue-resource"
Vue.use(vueResource)
import _ from 'lodash';
const baseUrl = process.env.API_ROOT;
Vue.http.options.emulateJSON = true;
Vue.http.interceptors.push((request, next) => {
	//   help.showLoading = true;    
	//you can do something in interceptors
	// request.headers.set('token':sessionStorage.getItem('token')||'');
	var TOKEN = sessionStorage.getItem('token') || '';
	// request.headers.set('token', TOKEN);
	//配置请求头
	next((response) => {
		if (!response) {
			//do something when response
		}
		return response;
	});
});
let loadingInstance; //loading 实例
let needLoadingRequestCount = 0; //当前正在请求的数量

function closeLoading() {
	Vue.nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
		needLoadingRequestCount--;
		needLoadingRequestCount = Math.max(needLoadingRequestCount, 0); // 保证大于等于0
		if (needLoadingRequestCount === 0) {
			if (loadingInstance) {
				hideLoading();
			}
		}
	});
}
var hideLoading = _.debounce(() => {
   loadingInstance.close();
   loadingInstance = null;
}, 300);

export function post(url, params,load=true) {
	if (load) {
		if (needLoadingRequestCount === 0 && !loadingInstance) {
			loadingInstance = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)',
				customClass: 'loading_mask',
			});
   		}
		needLoadingRequestCount++;
	}
	return new Promise((resolve, reject) => {
		var TokenId = sessionStorage.getItem('TokenId') || '';
		var lang  = localStorage.getItem('lang') || 'cn';
		var is_co  = sessionStorage.getItem('is_co');

		let d = Math.round(new Date(2022,0,1,0,0,0).getTime()/1000);
		let t = Math.round(Date.UTC(2022,0,1,0,0,0)/1000);
		var cha_time=t-d;

		params['cha_time']=cha_time;
		var y,m,dd,h,i,s;  
		var date = new Date();
		y = date.getFullYear();    //年
		m = date.getMonth();    // 月
		dd = date.getDate();    //日
		h = date.getHours();    //时
		i = date.getMinutes();    //分
		s = date.getSeconds();   //秒
		let tt = Math.round(Date.UTC(y,m,dd,h,i,s)/1000);
		params['utc_time']=tt;

		params['TokenId']=TokenId;
		params['language']=lang!='cn'?'us':'cn';
		if (is_co==1&&!params.country) {
			params['country']='co'
		}
		Vue.http.post(baseUrl + url, params ).then(res => {
			if (load) {
				closeLoading();
			}
			if (res.status == 200) {
				if (res.body.status == 200) {
					resolve(res.body.data);
				} else if(res.body.status == 401){
					sessionStorage.removeItem('token');
					this.$router.push('/login');
				} else {
					this.$message.error(res.body.message);
				}
			} else if(res.status == 0) {
				sessionStorage.removeItem('token');
				this.$router.push('/login');
			} else {
				this.$message.error(this.$t('index.please'));
			}
		}).catch((err) => {
			if (load) {
				closeLoading();
			}
			this.$message.error(err.body.message);
			// console.log(err)
			reject(err);
		});
	});
}
export function post_Export(url, params) {
	return new Promise((resolve, reject) => {
		var TokenId = sessionStorage.getItem('TokenId') || '';
		var lang  = localStorage.getItem('lang') || 'cn';
		var is_co  = sessionStorage.getItem('is_co');
		params['TokenId']=TokenId;
		params['language']=lang!='cn'?'us':'cn';
		if (is_co==1&&!params.country) {
			params['country']='co'
		}
		Vue.http.options.emulateJSON = false;
		Vue.http.post(baseUrl + url, params ).then(res => {
			if (res.status == 200) {
				if (res.body.status == 200) {
					resolve(res.body.data);
				} else if(res.body.status == 401){
					sessionStorage.removeItem('token');
					this.$router.push('/login');
				} else {
					this.$message.error(res.body.message);
				}
			} else if(res.status == 0) {
				sessionStorage.removeItem('token');
				this.$router.push('/login');
			} else {
				this.$message.error(this.$t('index.please'));
			}
		}).catch((err) => {
			console.log(err)
			reject(err);
		});
	});
}
export function get(url,params) {
	return new Promise((resolve, reject) => {
		var TokenId = sessionStorage.getItem('TokenId') || '';
		var lang  = localStorage.getItem('lang') || 'cn';
		var is_co  = sessionStorage.getItem('is_co');
		params['TokenId']=TokenId;
		params['language']=lang!='cn'?'us':'cn' ;

		if (is_co==1&&!params.country) {
			params['country']='co'
		}
		Vue.http.get(baseUrl + url,params ) .then((res) => {
			if (res.status == 200) {
				if (res.body.status == 200) {
					resolve(res.body.data);
				} else if(res.body.status == 401){
					sessionStorage.removeItem('token');
					this.$router.push('/login');
				} else {
					this.$message.error(res.body.message);
				}
			} else {
				this.$message.error(this.$t('index.please'));
			}
		}) .catch((err) => {
			if (loading) {
		        loading.close();
			}
			this.$message.error(err.body.message);
			reject(err);
		});
	});
}



//////////////////
// WEBPACK FOOTER
// ./store/vue_resource.js
// module id = null
// module chunks = 